export default __webpack_public_path__ + "static/posterbig-9c86e1e7a1df99719157aa486af821d8.png";